import userManagement from './userManagement';

import { applyMiddleware, compose, createStore } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { combineReducers } from '@reduxjs/toolkit';

const middlewareEnhancer = applyMiddleware(thunkMiddleware);
const composedEnhancers = compose(middlewareEnhancer);

const rootReducer = combineReducers({ userManagement });
const store = createStore(rootReducer, undefined, composedEnhancers);

export type RootState = ReturnType<typeof rootReducer>;

export default store;
